export const champions = [
  "Any",
  "Naafiri",
  "Milio",
  "Sylas",
  "Nidalee",
  "Ahri",
  "K'Sante",
  "Kassadin",
  "Udyr",
  "Bardo",
  "Nilah",
  "Twisted Fate",
  "Graves",
  "Kai'Sa",
  "Bel'Veth",
  "Renata Glasc",
  "Aatrox",
  "Ekko",
  "Zeri",
  "Taliyah",
  "Pantheon",
  "Caitlyn",
  "Zac",
  "Viktor",
  "Vi",
  "Lucian",
  "Jinx",
  "Sejuani",
  "Lissandra",
  "Ashe",
  "Zyra",
  "Zoe",
  "Zilean",
  "Ziggs",
  "Zed",
  "Yuumi",
  "Yorick",
  "Yone",
  "Yasuo",
  "Xin Zhao",
  "Xerath",
  "Xayah",
  "Warwick",
  "Volibear",
  "Vladimir",
  "Viego",
  "Vex",
  "Vel'Koz",
  "Veigar",
  "Vayne",
  "Varus",
  "Urgot",
  "Twitch",
  "Tryndamere",
  "Trundle",
  "Tristana",
  "Thresh",
  "Teemo",
  "Taric",
  "Talon",
  "Tahm Kench",
  "Syndra",
  "Swain",
  "Soraka",
  "Sona",
  "Skarner",
  "Sivir",
  "Sion",
  "Singed",
  "Shyvana",
  "Shen",
  "Shaco",
  "Sett",
  "Seraphine",
  "Senna",
  "Samira",
  "Ryze",
  "Rumble",
  "Riven",
  "Rengar",
  "Renekton",
  "Rell",
  "Rek'Sai",
  "Rammus",
  "Rakan",
  "Quinn",
  "Qiyana",
  "Pyke",
  "Poppy",
  "Ornn",
  "Orianna",
  "Olaf",
  "Nunu y Willump",
  "Nocturne",
  "Neeko",
  "Nautilus",
  "Nasus",
  "Nami",
  "Morgana",
  "Mordekaiser",
  "Wukong",
  "Miss Fortune",
  "Maestro Yi",
  "Maokai",
  "Malzahar",
  "Malphite",
  "Lux",
  "Lulu",
  "Lillia",
  "Leona",
  "Lee Sin",
  "LeBlanc",
  "Kog'Maw",
  "Kled",
  "Kindred",
  "Kha'Zix",
  "Kennen",
  "Kayn",
  "Kayle",
  "Katarina",
  "Karthus",
  "Karma",
  "Kalista",
  "Jhin",
  "Jayce",
  "Jax",
  "Jarvan IV",
  "Janna",
  "Irelia",
  "Heimerdinger",
  "Hecarim",
  "Gwen",
  "Gragas",
  "Gnar",
  "Garen",
  "Gangplank",
  "Galio",
  "Fizz",
  "Fiora",
  "Fiddlesticks",
  "Ezreal",
  "Evelynn",
  "Elise",
  "Dr. Mundo",
  "Draven",
  "Diana",
  "Darius",
  "Corki",
  "Cho'Gath",
  "Cassiopeia",
  "Camille",
  "Braum",
  "Brand",
  "Blitzcrank",
  "Azir",
  "Aurelion Sol",
  "Aphelios",
  "Annie",
  "Anivia",
  "Amumu",
  "Alistar",
  "Akshan",
  "Akali",
  "Ivern",
  "Illaoi",
];
